import React, {useState, useEffect, useRef} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress  } from 'antd';
import { signer } from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {getBoxIndex, addBox,getBoxRecord,getBoxRate} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
  import './index.less';
import { max } from 'moment';
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}

const Box = (props) => {
     const audioRef = useRef(null);
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [mars_n,setMarsN] = useState("")
    const [boxPrice,setBoxPrice] = useState("")
   const [level,setLevel] = useState("")
    const [level1,setLevel1] = useState("")
     const [level2,setLevel2] = useState("")
      const [level3,setLevel3] = useState("")
       const [level4,setLevel4] = useState("")
        const [level5,setLevel5] = useState("")
         const [level6,setLevel6] = useState("")
          const [level7,setLevel7] = useState("")
           const [level8,setLevel8] = useState("")
            const [level9,setLevel9] = useState("")
            const [level10,setLevel10] = useState("")
            const [level11,setLevel11] = useState("")
            const [level12,setLevel12] = useState("")
            const [level13,setLevel13] = useState("")
            const [level14,setLevel14] = useState("")
 
    const [heroImg,setHeroImg] = useState()
    const [lp,setLp] = useState(0)

    const [isLock,setIsLock]=useState(false)

    const [list,setList] = useState([])
    const [list1,setList1] = useState([])
    const [isOpen,setIsOpen] = useState(false)
    const [showRecord,setShowRecord] = useState(false)
    const [showRate,setShowRate] = useState(false)
    const timeoutId = useRef(null)

    const [par,setPar] = useState(0)
    const [minted,setMinted] = useState(0)

    
    const _getRate = () =>{
        if(props.address.length<=0){
            message.error(t('node.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('node.请先绑定地址'))
            return false
        }

        getBoxRate().then(res=>{
            if(res.code === 0 ){
    
                  
                if(res.data.list != null){
                    setList1(res.data.list)
                    
                }
                setShowRate(true)

            }else{
                message.error(res.msg)
            }
            
        },error=>{
            
            message.error(error)
        })
    
        
    }

    const _getRecord = () =>{
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.推荐人地址不能为空'))
            return false
        }

        getBoxRecord().then(res=>{
            if(res.code === 0 ){
    
                  
                if(res.data.list != null){
                    setList(res.data.list)
                    
                }
                setShowRecord(true)

            }else{
                message.error(res.msg)
            }
            
        },error=>{
            
            message.error(error)
        })
        
    
        
    }

   const _rand = () =>{
    message.error(t('g.暂未开始'))
       return
    if(props.address.length<=0){
        message.error(t('head.请先连接钱包'))
        return false
    }
    if(props.isLogin === false){
        message.error(t('head.推荐人地址不能为空'))
        return false
    }

    if(parseFloat(boxPrice)>parseFloat(mars_n)){
      
        message.error(t('box.余额不足'))
        return false
    }

    if(isLock){
        return false
    }
    setIsLock(true)
    setLevel("")
    signer(props.address).then(res=>{
        
        addBox({address:props.address,pass:res.pass}).then(res=>{
            if(res.code===0){
                audioRef.current.play()
                 setLevel(res.data.level)
                 
                 setIsOpen(!isOpen)
              
                setNum(num+1);
                
                
            }else{
                message.error(res.msg)
            }
            setIsLock(false)
            
        },error=>{
            setIsLock(false)
            message.error(res.msg)
        })

    },error=>{
        setIsLock(false)
    })
   

    
   }

   


   const _getBoxIndex= () =>{
    if(props.address.length === 0 || props.isLogin === false){
        return false
    }
    getBoxIndex().then(res=>{
        if(res.code === 0 ){

            setMarsN(res.data.mars)
            // let price = res.data.price
            // let _boxPrice = parseInt(100 / price * 100) / 100
            setBoxPrice(res.data.price)
            setLevel1(res.data.level1)
            setLevel2(res.data.level2)
            setLevel3(res.data.level3)
            setLevel4(res.data.level4)
            setLevel5(res.data.level5)
            setLevel6(res.data.level6)
            setLevel7(res.data.level7)
            setLevel8(res.data.level8)
            setLevel9(res.data.level9)
            setLevel10(res.data.level10)
            setLevel11(res.data.level11)
            setLevel12(res.data.level12)
            setLevel13(res.data.level13)
            setLevel14(res.data.level14)
            // setMinted(res.data.minted)
            // if(res.data.minted >0){
            //     let _par =  Math.round(res.data.minted / 5000 *10000)/100
            //     if(_par >100){
            //         _par = 100
            //     }
            //     setPar(_par)
            // }
            // if(res.data.list != null){
            //     setList(res.data.list)
            // }

        }else{
            message.error(res.msg)
        }
    },error =>{
        message.error(error)
    })

}
   

  
    

  
  



    useEffect(() => {
        window.scrollTo(0, 0)
        _getBoxIndex()
        
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

  

    return (
        <>
        
           111
        </>
        
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Box);
